"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jquery_1 = __importDefault(require("jquery"));
jquery_1["default"].widget('IKS.hallorequireparagraphs', {
    options: {
        editable: null,
        uuid: '',
        blockElements: [
            'dd',
            'div',
            'dl',
            'figure',
            'form',
            'ul',
            'ol',
            'table',
            'p',
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6'
        ]
    },
    cleanupContentClone: function (el) {
        // if the editable element contains no block-level elements wrap the contents in a <P>
        if (el.html().length && !jquery_1["default"](this.options.blockElements.toString(), el).length) {
            this.options.editable.execute('formatBlock', 'p');
        }
    }
});
